import axios from "axios"
import Cookies from 'js-cookie'
import { getStorageItem } from "../../helpers/storageManager"


const isConcurrencyEnabled = window?.app_data?.appcmsPlatform?.tveSettings?.tveConcurrency?.enabled
const concurrencyBaseUrl = window?.app_data?.appcmsPlatform?.tveSettings?.tveConcurrency?.baseUrl
const webApplicationId = window?.app_data?.appcmsPlatform?.tveSettings?.tveConcurrency?.applicationId
const concurrencyIdpValue = window?.app_data?.appcmsPlatform?.tveSettings?.tveConcurrency?.idpValue
let heartBeatInstance

const getConcurrencyMetaData = () => {
try {
    if(isConcurrencyEnabled){
        return axios({
            method: 'GET',
            url: `${concurrencyBaseUrl}/v2/metadata`,
            auth: {
                username: webApplicationId,
                password: ''
            }
        })
        .then((res) =>{
          return res.data
        })
    }else{
        console.log('Concurrency not enabled')
    }
} catch (error) {
    console.log(error)
}
}

const createConcurrencySession = async(renderErrorWall) => {
    try {
        const AuthenticationStore = getStorageItem('AuthenticationStore')
        const anonymousUserId  = await Cookies.get('anonymousUserId')
        const user = AuthenticationStore?.user
        const userId = user ? AuthenticationStore?.user?.userId : anonymousUserId
        const isTveLoggedIn = (user?.tveProvider || user?.tveMetadata?.tveProvider)
        const tveUserId = user?.tveMetadata?.tveUserId
        const loggedInMvpd = user?.tveMetadata?.mvpdProvider
        
        const sessionBaseUrl = isTveLoggedIn ? `${concurrencyBaseUrl}/v2/sessions/${loggedInMvpd}/${tveUserId}` : `${concurrencyBaseUrl}/v2/sessions/${concurrencyIdpValue}/${userId}`
        let headers = {
            "Content-Type":"application/x-www-form-urlencoded"
          }
        return axios({
            method: 'POST',
            url: sessionBaseUrl,
            auth: {
                username: webApplicationId,
                password: ''
            },
            headers: headers
        })
        .then((res) =>{
          return res
        }).catch((error) => {
            if(error.response.status == 410){
                sessionStorage.removeItem('concurrencySessionId')
                initiateHeartbeatPolling('kill')
                console.log(error, 'Stream Lost')
                throw error
            }
            if(error.response.status == 409){
                const associatedAdvice = error.response.data.associatedAdvice[0]
                renderErrorWall(associatedAdvice?.message || "No more than 3 streams allowed")
                initiateHeartbeatPolling('kill')
                console.log(error, 'Stream Limit Full')
            }
            return error
        })
    } catch (error) {
        throw error
    }
}

const triggerConcurrencyheartbeat = async(sessionId, renderErrorWall) => {
    try {
        const AuthenticationStore = getStorageItem('AuthenticationStore')
        const anonymousUserId  = await Cookies.get('anonymousUserId')
        const user = AuthenticationStore?.user
        const userId = user ? AuthenticationStore?.user?.userId : anonymousUserId
        const isTveLoggedIn = (user?.tveProvider || user?.tveMetadata?.tveProvider)
        const tveUserId = user?.tveMetadata?.tveUserId
        const loggedInMvpd = user?.tveMetadata?.mvpdProvider
        
        const sessionBaseUrl = isTveLoggedIn ? `${concurrencyBaseUrl}/v2/sessions/${loggedInMvpd}/${tveUserId}/${sessionId}` : `${concurrencyBaseUrl}/v2/sessions/${concurrencyIdpValue}/${userId}/${sessionId}`
        return axios({
            method: 'POST',
            url: sessionBaseUrl,
            auth: {
                username: webApplicationId,
                password: ''
            }
        })
        .then((res) =>{
            const expiryTimestamp = res?.headers?.expires
            const currentTime = new Date().getTime()   // In seconds
            const expiryTime = new Date(expiryTimestamp).getTime()  // In seconds
            const triggerTime = Math.floor(expiryTime - currentTime)
            heartBeatInstance = setTimeout(() => {
                if(expiryTimestamp && triggerTime > 0) triggerConcurrencyheartbeat(sessionId, renderErrorWall)
            }, triggerTime);
        }).catch((error) => {
            if(error.response.status == 410){
                console.log(error, 'Stream Lost')
                if(error?.response?.data == ""){
                    renderErrorWall("Current Session Expired")
                    initiateHeartbeatPolling('kill')
                }
                else renderErrorWall(error?.response?.data?.associatedAdvice[0]?.message || "This session was terminated by a remote session")
                sessionStorage.removeItem('concurrencySessionId')
                initiateHeartbeatPolling('kill')
                throw error
            }
            if(error.response.status == 409){
                initiateHeartbeatPolling('kill')
                console.log(error, 'Stream Limit Full heartBeat')
            }
            return error
        })
    } catch (error) {
        throw error
    }
}

const terminateConcurrencySession = async() => {
    try {
        const getCurrentSesssionId = sessionStorage.getItem('concurrencySessionId')
        const AuthenticationStore = getStorageItem('AuthenticationStore')
        const anonymousUserId  = await Cookies.get('anonymousUserId')
        const user = AuthenticationStore?.user
        const userId = user ? AuthenticationStore?.user?.userId : anonymousUserId
        const isTveLoggedIn = (user?.tveProvider || user?.tveMetadata?.tveProvider)
        const tveUserId = user?.tveMetadata?.tveUserId
        const loggedInMvpd = user?.tveMetadata?.mvpdProvider

        if(getCurrentSesssionId){
            const sessionBaseUrl = isTveLoggedIn ? `${concurrencyBaseUrl}/v2/sessions/${loggedInMvpd}/${tveUserId}/${getCurrentSesssionId}` : `${concurrencyBaseUrl}/v2/sessions/${concurrencyIdpValue}/${userId}/${getCurrentSesssionId}`
        return axios({
            method: 'DELETE',
            url: sessionBaseUrl,
            auth: {
                username: webApplicationId,
                password: ''
            }
        })
        .then((res) =>{
            sessionStorage.removeItem('concurrencySessionId')
            return res
        }).catch((error) => {
            if(error.response.status == 410){
                sessionStorage.removeItem('concurrencySessionId')
            }
        })
        }
    } catch (error) {
        throw error
    }
}

const initiateConcurrency = (renderErrorWall) => {
    if(isConcurrencyEnabled){
    try {
        getConcurrencyMetaData().then((data) => {
        createConcurrencySession(renderErrorWall).then((res) => {
            const expiryTimestamp = res?.headers?.expires
            const currentTime = new Date().getTime()   // In seconds
            const expiryTime = new Date(expiryTimestamp).getTime()  // In seconds
            const triggerTime = Math.floor(expiryTime - currentTime)
            if(res?.headers?.location) {
                sessionStorage.setItem('concurrencySessionId', res.headers.location)
                setTimeout(() => {
                    initiateHeartbeatPolling('initiate', renderErrorWall)
                }, triggerTime);
            }
        }).catch((error) => {
            console.log(error)
        })
    })
    } catch (error) {
        throw error
    }
    }
}
const initiateHeartbeatPolling = (type, renderErrorWall) => {
    if(type == "initiate"){
        const getCurrentSesssionId = sessionStorage.getItem('concurrencySessionId')
        getCurrentSesssionId && getCurrentSesssionId != undefined && getCurrentSesssionId != 'undefined' && triggerConcurrencyheartbeat(getCurrentSesssionId, renderErrorWall).then((res) => {
        }).catch((error) => {
            clearTimeout(heartBeatInstance)
            console.log(error)
        })
    }
    if(type == "kill"){
        clearTimeout(heartBeatInstance);
        sessionStorage.removeItem('concurrencySessionId')
    }
    if(type == "terminatePolling"){
        clearTimeout(heartBeatInstance);
    }
} 

const handleNextStreamPlaybackContent = (isPlayable, renderConcurrencyMessageWall) => {
    if(isConcurrencyEnabled && isPlayable){
        terminateConcurrencySession().then(() => {
        initiateHeartbeatPolling('terminatePolling')
        initiateConcurrency(renderConcurrencyMessageWall)
        })
    }
    if(isConcurrencyEnabled && !isPlayable){
      terminateConcurrencySession()
      initiateHeartbeatPolling('kill')
    }
}


export{getConcurrencyMetaData, createConcurrencySession, triggerConcurrencyheartbeat, terminateConcurrencySession, initiateConcurrency, initiateHeartbeatPolling, handleNextStreamPlaybackContent}